import { SclaApplication } from 'features/scla/types';
import { makePutRequest } from 'lib/axios';

export interface ISignatureDetailsPayload {
  studentFullName: string;
  studentSignedDate: string;
  parentFullName: string;
  parentSignedDate: string;
  parentIsAdult: boolean;
  informationConfirmed: boolean;
}

const updateSclaSignatureDetails = async (
  id: string,
  payload: ISignatureDetailsPayload,
): Promise<SclaApplication> => {
  const url = `/scla/application/signature/details/${id}`;
  const response = await makePutRequest(url, payload);
  return response.data.payload;
};

export default updateSclaSignatureDetails;
